import * as Yup from 'yup'
import { REJECT_REASON } from 'domains/seller-rejected-product/constants'


const sellerInboundCurateRejectProductSchema = Yup.object().shape({
  category     : Yup.number(),
  brand        : Yup.number(),
  colour       : Yup.array(),
  product_info : Yup.string().required('Required'),
  reason       : Yup.string().oneOf(
    Object.values(REJECT_REASON),
    'Please choose one'
  ).required('Required')
})

export default sellerInboundCurateRejectProductSchema
